import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Inject,
  ChangeDetectorRef
} from '@angular/core';
import { Observable, interval } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { UserService } from '../../services/user.service';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import * as fromStore from '../../store';
import { UsersState } from '../../store/reducers/user.reducers';
import { distinctUntilChanged, take, takeUntil, tap } from 'rxjs/operators';
import { Subscription, combineLatest } from 'rxjs';
import 'chartjs-plugin-datalabels';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { isODM, Confirm_button, environment, SSOURL } from '../../../environments/environment';
import {
  LangList,
  PackageList,
  PackageLevel,
  urlPath,
  updateInfoType,
  CompanionStatus,
  geteventEmitterType,
  SmartPowerReportPlan} from '../../shareModel';
import { AppConfigService } from '../../services/app-config.service';
import { WindowService } from '../../services/window.service';
import { AccountService } from '../../services/account.service';
import { ChangePasswordInfo } from '../../models/account';
import { Subject } from 'rxjs';
import { UserPackages } from '../../my-features/purchase/purchase.model';
import { LanguageService } from '../../services/language.service';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import set = Reflect.set;
import { PreferenceService } from '../../services/preference.service';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import * as fromFeature from '../../my-features';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { AddContactUsParams } from 'src/app/my-features/contact-us/contact-us.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import { SummaryActionTypes } from '../../my-features';
import { Preference } from '../../my-features/summary/summary.model';
import { RegionService } from 'src/app/services/region.service';
import { UtilsService } from '../../services/utils.service';
import {CryptoService} from '../../services/crypto.service';
import {SmartPowerReportService} from '../../services/smart-power-report.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';


@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {
  mspCompanyOptions = [];
  mspCompanySelected = [];
  // Summary
  summaryDashboardchecked = true;
  summaryEmailchecked = true;
  showSummary = true;
  summaryRangeOptions = [
    { label: this.translateService.instant('Last 7 Days'), value: 1, disabled: false },
    { label: this.translateService.instant('Last 30 Days'), value: 2, disabled: false },
  ];
  selectedSummaryRange = [1];
  hideDashboardSummary = false;

  dateFormatOptions: SelectItem[] = [
    { label: 'yyyy/MM/dd', value: 'yyyy/MM/dd' },
    { label: 'MM/dd/yyyy', value: 'MM/dd/yyyy' },
    { label: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
  ];
  temperatureUnitOptions: SelectItem[] = [
    { label: this.translateService.instant('Celsius') + '（˚C）', value: '℃' },
    { label: this.translateService.instant('Fahrenheit') + '（˚F）', value: '℉' },
  ];
  displayPreferencesDialog = false;
  languageOptions: SelectItem[] = LangList;
  selectedLanguage = 'en';
  selectedDateFormat = 'yyyy/MM/dd';
  selectedTemperatureUnit = '℃';
  selectDefaultHomePage = 0;
  selectedEnableOTP = false;
  accountSettingHeader = 'Account Setting';
  showAdminHeader = true;
  isProd = environment.production;
  isLogIn: boolean;
  loginStatus: Subscription;
  options: any = {
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#ffffff',
          font: {
            size: 13,
          },
          usePointStyle: true,
        },
      },

      datalabels: {
        color: '#ffffff',
        align: 'center',
        anchor: 'center',

        formatter: (value: number) => {
          return value;
        },

        // 隱藏數值0
        display: function (context) {
          return (
            context.dataset.data[context.dataIndex] !== 0 &&
            context.chart.isDatasetVisible(context.datasetIndex)
          );
        },
      },
    },
  };
  plugins: any[] = [ChartDataLabels];
  data: any = [];
  displayConfirmDialog = false;
  displayChangePasswordDialog = false;
  scrollPanelHeight: number;
  cplogoheight: number;
  headerheight: number;
  chartheight: number;
  chartData = true;

  items: MenuItem[];
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  shareModel = {
    PackageList: PackageList,
    urlPath: urlPath,
  };
  public innerWidth: any;
  public innerHeight: any;
  packageStatus$: Observable<any>;
  packageStatus: any;
  packageUsing: any;
  isAdmin = false;
  isSuperAdmin = false;
  isMsp = false;
  isMspLoaded = false;
  acode: number;
  regionList: any;
  logoPath: any;
  ChangePasswordInfo: ChangePasswordInfo = {
    Account: '',
    Package: '',
    Password: '',
    NewPassword: '',
  };
  ConfirmPassword = '';
  ChangePasswordButton_dirty = false;
  hostName: string;
  packageInfo = {
    RemainDays: NaN,
    Waiting: '',
  };
  splitMenu: any = {
    0: TRANSLATE('Account Info'),
    1: TRANSLATE('Purchase Plan'),
    2: TRANSLATE('Preferences'),
    3: TRANSLATE('Log Out'),
    4: TRANSLATE('Share Device'),
    5: TRANSLATE('Change Password'),
    6: TRANSLATE('System Logs'),
  };
  disabledGlobalMapOpt: Boolean = false;
  private componentDestroyed = new Subject();

  contactSidebar = false;
  categoryOptions: SelectItem[] = [];

  ContactUsInput: AddContactUsParams = {
    otp: '',
    category: '',
    msg: '',
  };
  dialogSaveDirty = false;
  showNewNotifi = false;
  notificationListCount = 0;
  notificationList = [];
  UpdateInfoParam = {} as UpdateInfoModel;
  asideView = true;
  menuControl = true;
  PreferencParam: Preference[];
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  shareDeviceFeature: Boolean;
  contactUsMargin = false;
  planAccountInfo$: Observable<any>;
  displayCompanionAlert = false;
  closeDisplayCompanionAlert = false;
  displayCompanion = false;
  accountPackageLevelFlag = false;
  accountPlanFlag = false;
  pageloading = true;
  regionId: number;
  mspManagement: string;
  regionDic: any = [];
  mspSelectedRegionId = [];
  mspCompanyOptionsDic = {};
  mspMemberAuthorityDic = {};
  ViewSidebar = true;
  mspActive = false;
  displayCookiesDialog = false;
  cookieAgreed = false;
  displayReportCheckDialog = false;
  latestSmartPowerReportId = null;
  latestSmartPowerReportType = null;
  planInfo: any;
  smartPowerReportPlan = SmartPowerReportPlan;
  constructor(
    private elementRef: ElementRef,
    private userService: UserService,
    private router: Router,
    private store: Store<fromStore.State>,
    private appConfigService: AppConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private windowService: WindowService,
    private accountService: AccountService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private preferenceService: PreferenceService,
    private fb: FormBuilder,
    private ngxService: NgxUiLoaderService,
    private regionService: RegionService,
    private utils: UtilsService,
    private cryptoService: CryptoService,
    private smartPowerReportService: SmartPowerReportService
    
  ) {
    if (this.powerMaster) {
      this.CheckCustmizeDomain();
    }
    // Init Language Option
    if (this.languageService.getLanguage) {
      this.selectedLanguage = this.languageService.getLanguage;
    }

    // Init Date Format Option
    if (this.preferenceService.GetDateFormat) {
      this.selectedDateFormat = this.preferenceService.GetDateFormat;
    }

    // Init Temp Unit Option
    if (this.preferenceService.GetTempUnit) {
      this.selectedTemperatureUnit = this.preferenceService.GetTempUnit;
    }
    this.store.dispatch(new fromFeature.GetPreferences());
    this.getPreferences();

    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe((res) => {
      this.ChangePasswordInfo.Account = res.currentUser;
      this.ChangePasswordInfo.Package = res.Package;
      this.isAdmin = res.authority && res.authority > 0 ? true : false;
      this.isSuperAdmin = res.authority && res.authority === 2 ? true : false;
      this.regionId = res.RegionId;
      this.acode = res.acode;
      if (!res.isLogin && !res.isLoading && res.isLoaded) {
        const token = JSON.parse(this.utils.getToken());
        const ssouser = (token && token.ssouser) ? token.ssouser : '';

        if (ssouser) {
          this.utils.removeToken();
          if (token.ssocookie) {
            this.utils.writeToken({ ssocookie: token.ssocookie });
          }
          // const url = 'http://localhost:8080/sso/logout';
          // const url = 'https://powerpaneldemo.cyberpower.com/sso/logout';
          const url = SSOURL.backendURL + '/sso/logout';
          window.location.href = url;
        } else {
          this.ngxService.stop();
          this.router.navigate(['/login']);
        }
      }
    });

    this.logoPath = this.regionService.GetLogoPath;

    // Get HostName & Region Info For Logo Path
    // this.hostName = this.windowService.getHostName();

    this.store.select(fromStore.getIsMsp).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // tslint:disable-next-line:no-debugger
      if (res !== undefined && res !== null) {
        this.isMsp = res;
        this.isMspLoaded = true;
        if (!this.powerMaster && this.items && this.items.length > 2) { // 特殊處理, 因為 isMsp 確定的時間有可能比產生右上角選單 splitMenuLanguage() 快或慢
          this.items[1].visible = res ? false : true;  // 根據 isMsp 決定是否顯示 Purchase Plan
        }
      }
    });

    this.store
      .select(fromStore.getRegions)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res.length > 0) {
          const region = this.windowService.getLogoRegion(res);
          if (typeof region !== 'undefined' && region !== null) {
            this.regionService.SetLogoPath = region.Note;
            this.logoPath = region.Note;
          }
          if (
            this.isMsp && (
            this.isAdmin === false ||
            this.isSuperAdmin === false)) {
            const mspMainRegionItem = res.find(r => r.Admins !== undefined && r.Admins.filter(i => i === this.acode) !== undefined);
            const mspMainRegionId = mspMainRegionItem !== undefined ? mspMainRegionItem.MspMainRegionId : undefined;
            this.mspManagement = this.cryptoService.aesEncrypt(mspMainRegionId);
          }
          // this.hostName = window.location.hostname;
          // const logoPath = res.find(i => i.Domain != null && i.Domain.toLowerCase().includes(this.hostName.toLowerCase()));
          // if (typeof logoPath !== 'undefined' && logoPath !== null) {
          //   this.logoPath = logoPath.Note;
          // }
        }
      });

    // Get Module for Side Bar Authority
    // this.packageStatus$ = this.store.pipe(select(fromStore.getUserAllModule));
    this.store
      .pipe(select(fromStore.getUserAllModule), takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.packageStatus = res;
        if (Object.keys(res).length > 0) {
          // tslint:disable-next-line:triple-equals
          this.disabledGlobalMapOpt =
            res[this.shareModel.PackageList.GlobalMap].Value === '0';
        }
      });

    // Get Purchase Packages Info
    this.store
      .select(fromStore.getUserPackages)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        // Status: Available(0), Using(1), Waiting(2), Expired(3)
        // MspUsingStatus: Available(0), Using(1), Expired(2)
        if (res && res.length > 0) {
          const packageUsing = res.find((i) => i.Status === 1),
            packageWaiting = res.find((i) => i.Status === 2);
          this.packageInfo.RemainDays = packageUsing
            ? packageUsing.PackageRemainDay
            : NaN;
          this.packageInfo.Waiting = packageWaiting
            ? packageWaiting.Package
            : '';
          this.packageUsing = packageUsing;
          // tslint:disable-next-line:max-line-length
          if (packageUsing === undefined || (packageUsing.Package === PackageLevel.StandardStr ||  packageUsing.Package === PackageLevel.AdvancedStr || packageUsing.Package === '')) {
          // Check Package level >= 2plus
            // this.displayCompanion = false;
            // this.displayCompanionAlert = false;
            this.accountPackageLevelFlag = false;
          } else {
            // PlanLevel >= 2Plus & (PageLevel = Premium || PageLevel = Superb)
              this.accountPackageLevelFlag = true;
            // if (this.accountPlanFlag) {
            //   this.ReadCompanionOverView();
            // }
          }
        }
      });

    // Get Notification List
    this.store
      .pipe(select(fromStore.getNotificationList), takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res.Loaded && !res.Loading) {
          this.showNewNotifi = !res.isConfirm;
          this.notificationListCount = res.isConfirm ? 0 : res.entities.length;
          this.notificationList = Array.isArray(res.entities)
            ? res.entities.map((e) => ({ ...e }))
            : [];
          setTimeout(() => {
            this.pageloading = false;
          }, 1000);
        }
      });

    // this.items = [
    //   {
    //     label: this.translateService.instant(this.splitMenu[0]),
    //     icon: 'pi pi-user',
    //     command: () => {
    //       if (!this.powerMaster) {
    //         this.router.navigate(['/account-info']);
    //       } else {
    //         this.showChangePasswordDialog();
    //       }
    //     },
    //   },
    //   // TODO Hide purchase entry.
    //   {
    //     label: this.translateService.instant(this.splitMenu[1]),
    //     icon: 'pi pi-money-bill',
    //     command: () => {
    //       if (!this.powerMaster) {
    //         this.router.navigate(['/purchase']);
    //       } else {
    //         this.showChangePasswordDialog();
    //       }
    //     },
    //   },
    //   {
    //     label: this.translateService.instant(this.splitMenu[6]),
    //     icon: 'pi pi-list',
    //     command: () => {
    //       this.router.navigate(['/systemlog']);
    //     },
    //   },
    //   {
    //     label: this.translateService.instant(this.splitMenu[2]),
    //     icon: 'pi pi-cog',
    //     command: () => {
    //       this.showLanguageDialog();
    //     },
    //   },
    //   {
    //     label: this.translateService.instant(this.splitMenu[3]),
    //     icon: 'pi pi-sign-out',
    //     command: () => {
    //       this.showConfirmDialog();
    //     },
    //   },
    // ];

    if (this.powerMaster) {
      this.splitMenu[0] = TRANSLATE('Account Setting');
    }

    // Chang Menu Language after selection was changed.
    this.translateService.onLangChange.pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (!this.powerMaster) {
        // SummaryRange Translate
        this.summaryRangeOptions[0].label = this.translateService.instant('Last 7 Days');
        this.summaryRangeOptions[1].label = this.translateService.instant('Last 30 Days');
        // Temperature Translate
        this.temperatureUnitOptions[0].label = this.translateService.instant('Celsius') + '（˚C）';
        this.temperatureUnitOptions[1].label = this.translateService.instant('Fahrenheit') + '（˚F）';
        // Unhide purchase entry
        this.items[0].label = this.translateService.instant(this.splitMenu[0]);
        this.items[1].label = this.translateService.instant(this.splitMenu[1]);
        this.items[2].label = this.translateService.instant(this.splitMenu[6]);
        this.items[3].label = this.translateService.instant(this.splitMenu[2]);
        this.items[4].label = this.translateService.instant(this.splitMenu[4]);
        this.items[5].label = this.translateService.instant(this.splitMenu[5]);
        this.items[6].label = this.translateService.instant(this.splitMenu[3]);
        // Hide purchase entry
        // this.items[0].label = this.translateService.instant(this.splitMenu[0]);
        // this.items[1].label = this.translateService.instant(this.splitMenu[2]);
        // this.items[2].label = this.translateService.instant(this.splitMenu[4]);
        // this.items[3].label = this.translateService.instant(this.splitMenu[5]);
        // this.items[4].label = this.translateService.instant(this.splitMenu[3]);
      } else {
        this.items[0].label = this.translateService.instant(this.splitMenu[0]);
        this.items[1].label = this.translateService.instant(this.splitMenu[1]);
        this.items[2].label = this.translateService.instant(this.splitMenu[3]);
      }
      this.getChart();
      this.readCategoryOptions();
    });

    // Get Current Route Path
    const appMainContent = document.getElementById('appMainContent');
    router.events.subscribe((event) => {
      // Admin以下的權限Key Management Url導回首頁
      if (event instanceof NavigationStart) {
        if (!this.isSuperAdmin) {
          if (this.isAdmin) {
            // Firmware／RMC：由 AuthFirmwareGuard + 後端 config.json firmwareAdmin 控管
            if ((event.url === ('/' + urlPath['LicenseMgtList']) && this.isMsp)
              || event.url === ('/' + urlPath['MacSnMgt']) || event.url === ('/' + urlPath['Package'])
              || event.url === ('/' + urlPath['PlanManagement'])
              || event.url === ('/' + urlPath['ProUpgrade'])) {
              this.router.navigate(['/dashboard']);
            }
          } else if (event.url.includes('/management')) {
            this.router.navigate(['/dashboard']);
          }
          if (event.url.startsWith('/' + urlPath['mobilePurchasePlan'])) {
            this.splitMenuLanguage();
          }
          if (event.url.startsWith('/management/admin/msp/')) {
            this.mspActive = true;
          } else {
            this.mspActive = false;
          }
        }
      }

      if (event instanceof NavigationEnd) {
        if (event.url === ('/' + urlPath['FirmwareMgt']) || event.url === ('/' + urlPath['MacSnMgt'])
         || event.url === ('/' + urlPath['ApiDocument']) || event.url.startsWith('/' + urlPath['mobilePurchasePlan'])
         || event.url === ('/' + urlPath['FirmwareRMCMgt']) || event.url === ('/' + urlPath['ProUpgrade'])) {
          this.asideView = false;
          this.menuControl = false;
          appMainContent.classList.remove('margin');
          if (event.url === ('/' + urlPath['ApiDocument'])) {
            this.ViewSidebar = false;
          }
        } else if (event.url === '/dashboard') {
          this.hideDashboardSummary = true;
          this.showSummary = this.summaryDashboardchecked;
          if (!this.powerMaster) {
            if (this.showSummary) {
              appMainContent.classList.add('margin');
              this.contactUsMargin = true;
            } else {
              appMainContent.classList.remove('margin');
              this.contactUsMargin = false;
            }
          }
        } else {
          this.contactSidebar = false;
          this.asideView = true;
          this.menuControl = true;
          this.hideDashboardSummary = false;
          appMainContent.classList.remove('margin');
          this.contactUsMargin = false;
        }
      }
    });

    this.store.select(fromStore.getIsActiveUserModule, PackageList.EventSummary).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      const packageEventSummary = Boolean(res);
      if (!packageEventSummary) {
        this.selectedSummaryRange = [1];
        this.summaryRangeOptions = [
          { label: this.translateService.instant('Last 7 Days'), value: 1 , disabled : false},
          { label: this.translateService.instant('Last 30 Days'), value: 2 , disabled : true},
        ];
      } else {
        // this.selectedSummaryRange = [1, 2];
        this.summaryRangeOptions = [
          { label: this.translateService.instant('Last 7 Days'), value: 1 , disabled : false},
          { label: this.translateService.instant('Last 30 Days'), value: 2 , disabled : false},
        ];
      }
    });

    this.store.select(fromStore.getIsActiveUserModule, PackageList.Companion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // const packageCompanion = Boolean(res);
      const packageCompanion = false;
      if (!packageCompanion) {
        this.displayCompanion = false;
        this.displayCompanionAlert = false;
        this.accountPlanFlag = false;
      } else {
        this.accountPlanFlag = true;
        this.displayCompanion = true;
        // this.displayCompanionAlert = true;
        this.ReadCompanionOverView();
      }
    });

    // Get Update Info
    this.store
      .select(fromStore.getUpdateInfoState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        // Add Contact Us
        if (res.type === updateInfoType.AddContactUs) {
          if (!res.isLoading && res.isLoaded && res.isSaved) {
            this.messageService.add({
              severity: 'success',
              summary: 'Your feedback has been sent out successfully',
            });
          } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
            this.messageService.add({
              severity: 'error',
              summary: 'Failure: please try again later',
            });
          }
          this.ReLoadUpdateState();
        }
      });

    this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
            // Function you want to call here
            if (this.accountPackageLevelFlag && this.accountPlanFlag) {
              this.closeDisplayCompanionAlert = false;
              this.ReadCompanionOverView();
            }
        }
    });

    // Get Msp Member Authority For Filter Bar
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getRegionState),
     this.store.select(fromStore.getMspMemberAuthority)) .pipe(takeUntil(this.componentDestroyed)).subscribe(([isMsp, regionState, auth]) => {
      if (isMsp !== undefined && regionState.Loaded && !regionState.Loading) {
        if (isMsp) {
          const region = Object.values(regionState.entities);
          if ((region.length > 0) && (auth !== null && Array.isArray(auth) && auth.length > 0)) {
            region.map((item) => {
              this.regionDic[item.Id] = item.RegionName;
            });
            this.mspCompanyOptions = [];
            this.mspCompanySelected = [];
            auth.map((m) => {
              if (this.regionDic[m.RegionId] !== null && this.regionDic[m.RegionId] !== undefined) {
                this.mspCompanyOptions.push({ label: this.regionDic[m.RegionId], value: m.RegionId});
                if (m.ViewDevice === 1) {
                  this.mspCompanySelected.push(m.RegionId);
                }
              }
            });
            this.regionService.SetRegionIds = this.mspCompanySelected.join(',');
            this.store.dispatch(new fromFeature.SelectMspRegionFilters([...this.mspCompanySelected]));
          }
        } else {
          this.store.dispatch(new fromFeature.SelectMspRegionFilters([]));
        }
      }
    });

    // 左上選單值有更新時
    // this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
    //   // this.mspSelectedRegionId = [];
    //   if (res !== undefined && res !== null && res.filterLoaded) {
    //     if (res.selectedId !== undefined && res.selectedId !== null && res.selectedId.length > 0) {
    //       // this.mspSelectedRegionId = res.selectedId;
    //       this.store.dispatch(new fromFeature.GetSummary({RegionIds: res.selectedId}));
    //     }
    //   }
    // });

    // 顯示Cookies視窗
    // this.displayCookiesDialog = true;

    // Get Plan Account Setting
    this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        let result = 0;
        const usingPlan = Object.values(res.entities).find((i: any) => i.Status === 1) as any;  // filter out using one.
        if (usingPlan) {
          this.planInfo = usingPlan;
        }
      }
    });

    // Check Report Cookies
    this.store.select(fromStore.GetSmartPowerReportList).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res !== undefined && res.length > 0) {
        this.displayReportCheckDialog = false // 上正機先都不要跳出來ReportCheckDialog
        if ((this.planInfo !== undefined && this.planInfo.Level >= this.smartPowerReportPlan.level && this.planInfo.NodeTotal >= this.smartPowerReportPlan.nodes) || this.isMsp) { // Level必須大於10才能看到SmartPowerReport的功能
          const checkReportCookies = this.smartPowerReportService.GetCheckReport;
          let displayReportCheck = false;
          if (checkReportCookies !== null) { // 代表已經有紀錄點擊過CheckReport
            const reportId = parseInt(this.cryptoService.aesDecrypt(checkReportCookies));
            res.map(s=>{
              if (s.Id !== undefined && s.Id > reportId) { // 若其中有Id大於網站中紀錄的ReportId則代表有產出新的Report且沒有點擊
                displayReportCheck = true;
                this.latestSmartPowerReportId = s.Id;
                this.latestSmartPowerReportType = s.ReportType; // 顯示ReportType
              }
            });
          } else { // 網站上沒有紀錄任何點擊過CheckReport的操作
            displayReportCheck = true;
            const latestSmartPowerReport = res.reduce((prev, current) => {
            return (prev.Id > current.Id) ? prev : current;});
            if (latestSmartPowerReport !== null) {
              this.latestSmartPowerReportId = latestSmartPowerReport.Id;
              this.latestSmartPowerReportType = latestSmartPowerReport.ReportType;
            }
          }
          const pathname = window.location.pathname;
          const targetPath = "/" + urlPath['Dashboard'];
          if (displayReportCheck && pathname.startsWith(targetPath)){
            this.displayReportCheckDialog = true;
          }
        }        
      }
    });
  }

  ReLoadUpdateState() {
    this.resetUpdateInfoState();
    this.ngxService.stop();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(
      new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam })
    );
  }

  ngOnInit() {
    this.UI();
    this.getChart();
    this.readCategoryOptions();
    this.logoPath = this.windowService.getLogoPath();
    this.splitMenuLanguage();
    this.initContactUsInput();
    this.readNotificationList();

    if (this.userService.GetRedirect === ('/' + urlPath['FirmwareMgt']) || this.userService.GetRedirect === ('/' + urlPath['MacSnMgt'])
     || this.userService.GetRedirect === ('/' + urlPath['ApiDocument'])
     || (this.userService.GetRedirect && this.userService.GetRedirect.startsWith('/' + urlPath['mobilePurchasePlan']))
     || this.userService.GetRedirect === ('/' + urlPath['FirmwareRMCMgt'])
     || this.userService.GetRedirect === ('/' + urlPath['ProUpgrade'])) {
      this.asideView = false;
      this.menuControl = false;
      const appMainContent = document.getElementById('appMainContent');
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('body-login');
      appMainContent.classList.remove('margin');
      if (this.userService.GetRedirect === ('/' + urlPath['ApiDocument'])) {
        this.ViewSidebar = false;
      }
      this.userService.SetRedirect = null;
      this.splitMenuLanguage();
    }
  }

  ngAfterViewInit() {
    if (this.asideView) {
      if (this.powerMaster) {
        this.headerheight =
          this.elementRef.nativeElement.querySelector(
            '.site-header'
          ).offsetHeight;
      } else {
        this.headerheight =
          this.elementRef.nativeElement.querySelector(
            '.site-header'
          ).offsetHeight;
        this.chartheight =
          this.elementRef.nativeElement.querySelector('.chart').offsetHeight;
        this.cplogoheight =
          this.elementRef.nativeElement.querySelector('.cplogo').offsetHeight;
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  getChart() {
    const self = this;
    this.store
      .select(fromStore.getDevicesTypeCount)
      .pipe(takeUntil(this.componentDestroyed))
      // .pipe(distinctUntilChanged((a, b)) => JSON.stringify(a.data) === JSON.stringify(b.data))
      .subscribe((res) => {
        if (res.isLoaded && !res.isLoading && res.data) {
          const data = res.data
            .filter((i) => i && i.label !== 'All')
            .map((i) => i.title);
          const isEmpty = data.every((i) => i === 0);
          self.data = {
            labels: isEmpty
              ? []
              : [
                this.translateService.instant('Normal'),
                this.translateService.instant('Warning'),
                this.translateService.instant('Critical'),
                this.translateService.instant('Offline'),
              ],
            datasets: isEmpty
              ? []
              : [
                {
                  data: data,
                  backgroundColor: [
                    '#1c9c48',
                    '#fdc503',
                    '#d51f35',
                    '#666666',
                  ],
                  borderColor: ['#3b3b3b', '#3b3b3b', '#3b3b3b', '#3b3b3b'],
                },
              ],
          };

          if (isEmpty === false) {
            this.chartData = true;
          } else {
            this.chartData = false;
          }
        } else {
          this.chartData = false;
        }
      });
  }

  logout() {
    this.displayConfirmDialog = false;
    this.store.dispatch(new fromStore.LogoutAction());
    this.userService.SetRedirect = null;
    this.ngxService.start();
    // this.router.navigate(['/login']);
  }

  menuBtn() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('layout-toggle');
    body.classList.remove('mobile-toggle');
    this.showAdminHeader = !this.showAdminHeader;
    // const collapseManagement = document.getElementById('collapseManagement');
    // collapseManagement.classList.add('show');
    this.scrollPanel();
  }

  splitMenuLanguage() {
    // console.log("splitMenuLanguage this.isMsp = " + this.isMsp);
    if (!this.powerMaster) {
      this.items = [
        {
          label: this.translateService.instant(this.splitMenu[0]),
          icon: 'pi pi-user',
          command: () => {
            this.router.navigate(['/account-info']);
          }
        },
        // TODO Hide purchase entry.
        {
          label: this.translateService.instant(this.splitMenu[1]),
          icon: 'pi pi-money-bill',
          command: () => {
            this.router.navigate(['/purchase']);
          },
          visible: (this.isMsp ? false : true) // 特殊處理, 因為 isMsp 確定的時間有可能比產生右上角選單 splitMenuLanguage() 快或慢
        },
        {
          label: this.translateService.instant(this.splitMenu[6]),
          icon: 'pi pi-list',
          command: () => {
            this.router.navigate(['/systemlog']);
          }
        },
        {
          label: this.translateService.instant(this.splitMenu[2]),
          icon: 'pi pi-cog',
          command: () => {
            this.showLanguageDialog();
          }
        },
        {
          label: this.translateService.instant(this.splitMenu[4]),
          icon: 'pi pi-user-plus',
          command: () => {
            this.shareDeviceFeature = true;
            if (this.shareDeviceFeature) {
              this.router.navigate(['/device-setting']);
            } else {
              this.childDialog.alertShareDevice();
            }
          }
        },
        {
          label: this.translateService.instant(this.splitMenu[5]),
          icon: 'pi pi-unlock',
          command: () => {
            window.open(
              environment.cyberpowerUrl + '/account/forgot',
              '_blank'
            );
          }
        },
        {
          label: this.translateService.instant(this.splitMenu[3]),
          icon: 'pi pi-sign-out',
          command: () => {
            this.showConfirmDialog();
          },
        },
      ];
    } else {
      this.items = [
        {
          label: this.translateService.instant(this.splitMenu[0]),
          icon: 'pi pi-user',
          command: () => {
            this.showChangePasswordDialog();
          },
        },
        {
          label: this.translateService.instant(this.splitMenu[2]),
          icon: 'pi pi-cog',
          command: () => {
            this.showLanguageDialog();
          },
        },
        {
          label: this.translateService.instant(this.splitMenu[3]),
          icon: 'pi pi-sign-out',
          command: () => {
            this.showConfirmDialog();
          },
        },
      ];
    }
  }

  mobilemenuBtn() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('layout-toggle');
    body.classList.toggle('mobile-toggle');
    this.showAdminHeader = true;
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    if (this.powerMaster) {
      body.classList.add('body-landing');
      body.classList.remove('layout-toggle');
    } else {
      body.classList.add('body-landing');
      body.classList.remove('layout-toggle');
    }

    if (innerWidth < 1024) {
      this.noChart();
    }

    if (innerWidth > 1024 && innerWidth < 1367) {
      body.classList.add('layout-toggle');
      this.showAdminHeader = false;
    } else {
      body.classList.remove('layout-toggle');
      this.showAdminHeader = true;
    }

    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
    body.classList.remove('body-help');
    body.classList.remove('body-addDevice');
  }

  hasChart() {
    this.scrollPanelHeight =
      self.innerHeight -
      this.headerheight -
      this.chartheight -
      this.cplogoheight;
  }

  noChart() {
    this.scrollPanelHeight = self.innerHeight - this.headerheight;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const body = document.getElementsByTagName('body')[0];
    if (event.target.innerWidth > 1024) {
      body.classList.remove('mobile-toggle');
      this.showAdminHeader = true;
    } else if (event.target.innerWidth < 1024) {
      body.classList.remove('layout-toggle');
      this.showAdminHeader = false;
    }

    if (event.target.innerWidth > 1024 && event.target.innerWidth < 1367) {
      body.classList.add('layout-toggle');
      this.showAdminHeader = false;
    } else {
      body.classList.remove('layout-toggle');
      this.showAdminHeader = true;
    }

    this.scrollPanel();
  }

  @HostListener('mouseover') onMouseOver() {
    this.scrollPanel();
  }

  scrollPanel() {
    if (this.powerMaster) {
      this.scrollPanelHeight = self.innerHeight - this.headerheight;
    } else {
      if (this.data.datasets === undefined) {
        this.scrollPanelHeight =
          self.innerHeight - this.headerheight - this.cplogoheight;
      }
      if (this.data.datasets.length === 0) {
        this.scrollPanelHeight =
          self.innerHeight - this.headerheight - this.cplogoheight;
      } else {
        this.scrollPanelHeight =
          self.innerHeight -
          this.headerheight -
          this.chartheight -
          this.cplogoheight;
      }
      const body = document.getElementsByTagName('body')[0];
      if (body.classList.contains('layout-toggle')) {
        this.scrollPanelHeight = self.innerHeight - this.headerheight;
      }

      if (innerWidth < 1024) {
        this.scrollPanelHeight =
          self.innerHeight - this.headerheight - this.cplogoheight;
      }
    }
  }

  showConfirmDialog() {
    this.displayConfirmDialog = true;
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('mobile-toggle');
  }

  showChangePasswordDialog() {
    this.ChangePasswordInfo.Password = '';
    this.ChangePasswordInfo.NewPassword = '';
    this.ConfirmPassword = '';
    this.ChangePasswordButton_dirty = false;
    this.displayChangePasswordDialog = true;

    if (!this.powerMaster) {
      this.accountSettingHeader = 'Account Info';
    } else {
      this.accountSettingHeader = 'Account Setting';
    }

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
  }

  changePassword() {
    this.ChangePasswordButton_dirty = true;
    if (
      this.ChangePasswordInfo.Password &&
      this.ChangePasswordInfo.NewPassword &&
      this.ConfirmPassword &&
      this.ChangePasswordInfo.NewPassword === this.ConfirmPassword
    ) {
      const params = { ...this.ChangePasswordInfo };
      this.accountService
        .ChangePassword(this.ChangePasswordInfo)
        .subscribe((res) => {
          this.displayChangePasswordDialog = false;
          if (res.Flag) {
            this.messageService.add({
              severity: 'success',
              summary: 'Update Success',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Update Fail',
            });
          }
        });
    }
  }

  showLanguageDialog() {
    this.displayPreferencesDialog = true;
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('mobile-toggle');
  }

  changeLanguage() {
    this.languageService.changeLanguage(this.selectedLanguage);
  }

  changeDateFormat() {
    this.preferenceService.SetDateFormat = this.selectedDateFormat;
  }

  changeTempUnit() {
    this.preferenceService.SetTempUnit = this.selectedTemperatureUnit;
    this.preferenceService.tempChangedDetect.next('change temp');
  }

  changeSummaryDashboard() {
    this.preferenceService.SetDefaultSummaryDashboard = this.summaryDashboardchecked;
    this.showSummary = this.summaryDashboardchecked;

    // const div = document.getElementById('DashBoradSummary');
    const appMainContent = document.getElementById('appMainContent');

    if (this.router.url === '/dashboard') {
      this.hideDashboardSummary = true;
      if (this.showSummary) {
        // div.classList.add('showSummaryContent');
        appMainContent.classList.add('margin');
        this.contactUsMargin = true;
      } else {
        appMainContent.classList.remove('margin');
        this.contactUsMargin = false;
      }
    } else {
      this.hideDashboardSummary = false;
      appMainContent.classList.remove('margin');
      this.contactUsMargin = false;
    }
  }

  changeSummaryEmail() {
    this.preferenceService.SetDefaultSummaryEmail = this.summaryEmailchecked;
    this.preferenceService.tempChangedDetect.next('change temp');
  }

  changeDefaultHomePage() {
    this.preferenceService.SetDefaultHomePage = Number(
      this.selectDefaultHomePage
    );
  }

  savePreferences() {
    this.changeLanguage();
    this.changeDateFormat();
    this.changeTempUnit();
    this.changeDefaultHomePage();
    const param = {
      DateFormat: this.selectedDateFormat,
      DefaultHomePage: Number(this.selectDefaultHomePage),
      EnableOTP: Boolean(this.selectedEnableOTP),
      Language: this.selectedLanguage,
      SummaryDashboard: Boolean(this.summaryDashboardchecked),
      SummaryEmail: this.summaryEmailchecked === true ? (this.selectedSummaryRange.length > 0 ? this.selectedSummaryRange : [1]) : [0],
      TemperatureUnit: this.selectedTemperatureUnit === '℃' ? 0 : 1,
      UpdateTime: '',
      acode: 0,
      CookieAgreed: this.cookieAgreed,
    };
    if (!this.powerMaster) {
      this.changeSummaryDashboard();
      this.changeSummaryEmail();
    }
    this.store.dispatch(new fromFeature.UpdatePreferences(param));
    this.displayPreferencesDialog = false;
    this.store.dispatch(new fromFeature.GetPlanSettings());
  }

  initContactUsInput() {
    this.ContactUsInput = {
      otp: '',
      category: '',
      msg: '',
    };
  }

  showContanctBox() {
    this.contactSidebar = true;
    this.dialogSaveDirty = false;
    this.initContactUsInput();
  }

  onSubmitContanct() {
    this.dialogSaveDirty = true;
    if (
      this.ContactUsInput.msg === '' ||
      this.ContactUsInput.category.length === 0
    ) {
      return;
    }
    this.store.dispatch(new fromFeature.AddContactUs({ ...this.ContactUsInput }));
    this.contactSidebar = false;
    this.initContactUsInput();
  }

  readNotificationList() {
    this.store.dispatch(new fromFeature.GetNotifications());
  }

  updateNotificaitonList() {
    if (this.showNewNotifi) {
      this.store.dispatch(new fromFeature.UpdateNotifications());
    }
  }

  notifiBoxOnShow() {
  }

  readCategoryOptions() {
    this.categoryOptions = [
      { label: this.translateService.instant('Select Category'), value: '' },
      {
        label: this.translateService.instant('Add Device'),
        value: 'Add Device',
      },
      { label: this.translateService.instant('Purchase'), value: 'Purchase' },
      { label: this.translateService.instant('Trial'), value: 'Trial' },
      { label: this.translateService.instant('Delete Account'), value: 'Delete Account' },
      { label: this.translateService.instant('Other'), value: 'Other' },
    ];
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  getPreferences() {
    // Get Preferences
    this.store.select(fromStore.getPreferences).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.Loaded && !res.Loading) {
        if (res.entities != null && res.entities !== undefined) {
          if (res.entities.Language != null && res.entities.Language !== '' && res.entities.Language !== 'undefined') {
            this.selectedLanguage = res.entities.Language;
          }
          if (res.entities.DateFormat != null && res.entities.DateFormat !== '' && res.entities.DateFormat !== 'undefined') {
            this.selectedDateFormat = res.entities.DateFormat;
          }
          if (res.entities.TemperatureUnit != null && res.entities.TemperatureUnit !== undefined) {
            if (res.entities.TemperatureUnit === 0) {
              this.selectedTemperatureUnit = '℃';
            } else {
              this.selectedTemperatureUnit = '℉';
            }
          }
          if (res.entities.DefaultHomePage != null && res.entities.DefaultHomePage !== undefined) {
            this.selectDefaultHomePage = res.entities.DefaultHomePage;
          }
          if (!this.powerMaster) {
            if (res.entities.SummaryDashboard != null && res.entities.SummaryDashboard !== undefined) {
              if (res.entities.SummaryDashboard) {
                this.summaryDashboardchecked = true;
              } else {
                this.summaryDashboardchecked = false;
              }

            }
            if (res.entities.SummaryEmail != null && res.entities.SummaryEmail !== undefined) {
              this.summaryEmailchecked = (res.entities.SummaryEmail.length > 0 && !res.entities.SummaryEmail.includes(0)) ? true : false;
              if (this.summaryEmailchecked) {
                this.selectedSummaryRange = res.entities.SummaryEmail;
              }
            }

            if (res.entities.EnableOTP != null && res.entities.EnableOTP !== undefined) {
              if (res.entities.EnableOTP) {
                this.selectedEnableOTP = true;
              } else {
                this.selectedEnableOTP = false;
              }
            }
            this.changeSummaryDashboard();
            this.changeSummaryEmail();
          }
          if (res.entities.EnableOTP != null && res.entities.EnableOTP !== undefined) {
            if (res.entities.EnableOTP) {
              this.selectedEnableOTP = true;
            } else {
              this.selectedEnableOTP = false;
            }
          }
          if (res.entities.CookieAgreed != null && res.entities.CookieAgreed !== undefined) {
            if (res.entities.CookieAgreed) {
              this.cookieAgreed = true;
              this.displayCookiesDialog = false;
            } else {
              this.displayCookiesDialog = true;
            }
          } else {
            this.displayCookiesDialog = true;
          }

          this.changeLanguage();
          this.changeDateFormat();
          this.changeTempUnit();
          this.changeDefaultHomePage();

          this.DefaultPreferences();
        }
      }
    });
  }

  DefaultPreferences() {
    // Init Language Option
    if (this.languageService.getLanguage) {
      this.selectedLanguage = this.languageService.getLanguage;
    }

    // Init Date Format Option
    if (this.preferenceService.GetDateFormat) {
      this.selectedDateFormat = this.preferenceService.GetDateFormat;
    }

    // Init Temp Unit Option
    if (this.preferenceService.GetTempUnit) {
      this.selectedTemperatureUnit = this.preferenceService.GetTempUnit;
    }

    // Init Default Home Page Option
    if (Number.isInteger(this.preferenceService.GetDefaultHomePage)) {
      this.selectDefaultHomePage = this.preferenceService.GetDefaultHomePage;
    }

    this.summaryDashboardchecked = this.preferenceService.GetDefaultSummaryDashboard;
    this.showSummary = this.preferenceService.GetDefaultSummaryDashboard;
    this.summaryEmailchecked = this.preferenceService.GetDefaultSummaryEmail;
  }

  CheckCustmizeDomain() {
    // 判斷是否客製化Domain,若有則跳轉
    const host = window.location.href;
    const pathname = window.location.pathname;
    if (this.shareModel.urlPath.CustmizeDomain.includes(pathname)) {
      if (
        this.regionService.GetEnableDomain &&
        this.regionService.GetDomainPath !== '' &&
        this.regionService.GetDomainPath != null &&
        !host.includes(this.regionService.GetDomainPath)
      ) {
        if (
          this.regionService.GetDomainPath.includes('http://') ||
          this.regionService.GetDomainPath.includes('https://')
        ) {
          window.location.href = this.regionService.GetDomainPath;
        } else {
          window.location.href = 'https://' + this.regionService.GetDomainPath;
        }
      }
    }
  }

  defaultDashboard() {
    // const div = document.getElementById('DashBoradSummary');
    const appMainContent = document.getElementById('appMainContent');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/dashboard') {
          this.showSummary = this.summaryDashboardchecked;
          this.contactSidebar = false;
          this.asideView = true;
          this.menuControl = true;
          this.hideDashboardSummary = true;
          if (this.showSummary) {
            // div.classList.add('showSummaryContent');
            appMainContent.classList.add('margin');
            this.contactUsMargin = true;
          } else {
            appMainContent.classList.remove('margin');
            this.contactUsMargin = false;
          }
        }
      }
    });
  }

  showCompanionAlert() {
    this.displayCompanionAlert = true;
  }

  closeCompanionAlert() {
    this.closeDisplayCompanionAlert = true;
  }

  ReadCompanionOverView() {
    this.store.select(fromStore.getCompanionOverView).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null && res.length > 0) {
          // tslint:disable-next-line:forin
          for (const i in res) {
            const item = res[i];
            if (item.Companion !== undefined && item.Companion !== null && item.Companion.length > 0) {
               const companionItem = item.Companion.filter(c =>
                (c.IsConfirm !== undefined || c.IsPass !== undefined) && (CompanionStatus[c.Status] !== 'Offline'));
               if (companionItem.length > 0) {
                this.showCompanionAlert();
                break;
               }
            }
          }
      }
    });
  }

  SelectByRegion() {
    if (this.mspCompanySelected.length > 0) {
      let isRefresh = false;
      // var selectedDic = {};
      const selectedDic = Object.assign({}, ...this.mspCompanySelected.map((x) => ({[x]: x})));
      const selectedDicLength = Object.keys(selectedDic).length;

      if (this.regionService.GetRegionIds != null &&
         this.regionService.GetRegionIds !== undefined && this.regionService.GetRegionIds.length > 0) {
        const idListFromStore = this.regionService.GetRegionIds.split(',').map(str => parseInt(str, 10));

        if (selectedDicLength === idListFromStore.length) {
          for (let i = 0; i < idListFromStore.length; i++) {
            const id = idListFromStore[i];
            if (selectedDic[id] === undefined) {
              isRefresh = true;
              break;
            }
          }
        } else {
          isRefresh = true;
        }
      } else {
        isRefresh = true;
      }

      // debugger;
      if (isRefresh) {
        this.store.dispatch(new fromFeature.SelectMspRegionFilters([...this.mspCompanySelected]));
        this.regionService.SetRegionIds = this.mspCompanySelected.join(',');
        this.regionService.triggerEvent(geteventEmitterType.SelectByRegion);
      }
    } else {
      if (this.regionService.GetRegionIds != null &&
         this.regionService.GetRegionIds !== undefined && this.regionService.GetRegionIds.length > 0) {
        const idListFromStore = this.regionService.GetRegionIds.split(',').map(str => parseInt(str, 10));
        this.mspCompanySelected = idListFromStore;
      }
    }
  }

  acceptCookies() {
    this.cookieAgreed = true;
    this.displayCookiesDialog = false;
    this.savePreferences();
  }

  checkReportRedirct(type: string) {
    if (this.latestSmartPowerReportId !== null) {
      this.smartPowerReportService.SetCheckReport = this.cryptoService.aesEncrypt(this.latestSmartPowerReportId);
    }
    this.displayReportCheckDialog = false;
    if (type !== null && type !== undefined && type !== '' && type === 'check') {
      this.router.navigate(['/smart-power-report']);
    }
  }
}
